/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Contains the names of all linkable lists for @see {@link Synqo.Cloud.Messages.Model.Api.ApiScalesToolRegistration}
 */
export class ScaleToolLinkLists {
    /**
     * Represents a list of linked mandanten
     */
    static readonly mandanten: string = 'mandanten';
}
